import './ItemUploadedFiles.scss';
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLoaderData } from 'react-router-dom';
import { addFiles } from '../../store/rootState';

import { ReactComponent as ClipIcon } from '../../assets/img/clip.svg';
import { ReactComponent as LoadIcon } from '../../assets/img/load.svg';
import { ReactComponent as DocIcon } from '../../assets/img/docIcon.svg';
import { ReactComponent as JpgIcon } from '../../assets/img/jpgIcon.svg';
import { ReactComponent as PdfIcon } from '../../assets/img/pdfIcon.svg';
import { ReactComponent as EyeSecondIcon } from '../../assets/img/eyeSec.svg';
import { COUNT_MONTH } from '../../utilsData';
import { nanoid } from 'nanoid';

export async function loader(loaderData: { params: any }) {
  return loaderData.params.id;
}

const setVisualData = (values: any) => {
  let newDate = new Date(values * 1000);
  return (
    (newDate.getDate() < 10 ? '0' + newDate.getDate() : newDate.getDate()) +
    ' ' +
    COUNT_MONTH[newDate.getMonth()] +
    /* ' ' +
    newDate.getFullYear() + */
    ' в ' +
    (newDate.getHours() < 10 ? '0' + newDate.getHours() : newDate.getHours()) +
    ':' +
    (newDate.getMinutes() < 10
      ? '0' + newDate.getMinutes()
      : newDate.getMinutes())
  );
};

const ItemUploadedFiles = () => {
  const dataLoadedFiles = useSelector(
    (state: any) => state.root.secondLoadedFiles
  );
  const dispath = useDispatch();
  const id = useLoaderData();
  const [filesList, setFilesList] = useState<any>([]);
  const [errorInput, setErrorInput] = useState(false);

  useEffect(() => {
    setFilesList(
      (document.querySelector('#upload-item-files') as HTMLInputElement)?.files
    );
  }, []);

  useEffect(() => {
    setFilesList([...filesList, ...dataLoadedFiles]);
  }, [dataLoadedFiles]);

  return (
    <div className="item-uploaded-files">
      {filesList !== undefined && filesList.length ? (
        <ul className="item-uploaded-files__list">
          {Array.from(filesList).map((item: any, index: number) => (
            <li
              className="item-uploaded-files__item"
              key={nanoid() + index + 'sfgsg'}
            >
              <a href="#" className="item-uploaded-files__link" download>
                {item?.type === 'doc' ||
                item?.type ===
                  'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ? (
                  <DocIcon />
                ) : item?.type === 'image/jpeg' ||
                  item?.type === 'image/svg+xml' ||
                  item?.type === 'image/webp' ||
                  item?.type === 'image/png' ? (
                  <JpgIcon />
                ) : item?.type === 'pdf' ? (
                  <PdfIcon />
                ) : (
                  ''
                )}
                <div className="item-files__info">
                  <p className="item-files__name">{item?.name}</p>
                  <div className="item-files__dop-info">
                    <span>{item?.size + ' Кб'}</span>
                    <LoadIcon />
                    <span>{setVisualData(item?.date)}</span>
                  </div>
                </div>
                {item?.description ? (
                  <p className="item-files__description">{item?.description}</p>
                ) : (
                  ''
                )}
                <div className="item-files__links-icon">
                  <button
                    href="#"
                    className="item-files__link-add item-files__link-add--eye"
                  >
                    <EyeSecondIcon />
                  </button>
                  <button
                    href="#"
                    className="item-files__link-add item-files__link-add--load"
                    download
                  >
                    <LoadIcon />
                  </button>
                </div>
              </a>
            </li>
          ))}
        </ul>
      ) : (
        ''
      )}
      <div className="item-uploaded-files__wrapper-input">
        <input
          type="file"
          name="upload-item-files"
          id="upload-item-files"
          className="item-uploaded-files__input visibility-hidden"
          multiple
          onChange={(e: any) => {
            setErrorInput(false);
            dispath(addFiles([]));
            let filesSize = 0;
            let createdArray = Array.from(e.target.files).map((item: any) => {
              let newObj: any = {};
              newObj['name'] = item?.name;
              newObj['date'] = item?.lastModified;
              newObj['size'] = item?.size;
              newObj['type'] = item?.type;
              filesSize += item?.size;
              return newObj;
            });
            if (Math.round(filesSize / 1024 / 1024) > 20) {
              setErrorInput(true);
              document
                .querySelector('.modal-wrapper--uploaded')!
                .classList.remove('open');
              document.querySelector('body')!.classList.remove('modal');
              return;
            }
            dispath(addFiles(createdArray));
          }}
        />
        <label
          htmlFor="upload-item-files"
          className="item-uploaded-files__button"
          onClick={() => {
            if (document.querySelector('.modal-wrapper--uploaded')) {
              document
                .querySelector('.modal-wrapper--uploaded')!
                .classList.add('open');
              document.querySelector('body')!.classList.add('modal');
            }
          }}
        >
          Прикрепить файл <ClipIcon />
        </label>
        {errorInput ? (
          <p className="item-uploaded-files__error">
            Размер ваших файлов больше 20мб, попробуйте загрузить другие
          </p>
        ) : (
          ''
        )}
      </div>
    </div>
  );
};

export default ItemUploadedFiles;
